import { UseFormReturn } from "react-hook-form"
import { NodeDefinition, Property, ScenarioNode } from "@/gen"
import FormField from "../FormField"
import FormBuilder from "."
import OptionalProperties from "./OptionalProperties"
import Combobox from "@/components/ui/combobox"

export interface ActionOperation {
  id: string
  label: string
  properties: Property[]
  optional_properties: {
    properties: Property[]
    label: string
    tip: string
  }
  dynamic_properties: {
    enabled: Property[]
    depends_on: string[]
  }
  default_properties_values: Record<string, any>
}
// interface Temporario
// TODO: pegar da api via kubb
export interface Action {
  id: string
  label: string
  operations: ActionOperation[]
}

export interface ActionOperatorRecord {
  [key: string]: ActionOperation
}

// interface ActionGroup {
//   type: "action_group"
//   label?: string
//   actions?: Action[]
// }

export interface ActionFormBuilderProps {
  nodeDef: NodeDefinition
  actionOperationsRecord: ActionOperatorRecord
  form: UseFormReturn<any, any, undefined>
  selectedOperation?: ActionOperation
  nodeType: string
  meta_properties: ScenarioNode["meta_properties"]
  actionOperationProperties: Property[]
  optionalActionOperationProperties: Property[]
  actionId?: string
  operationId?: string
}

function ActionFormBuilder(props: ActionFormBuilderProps) {
  // const meta_properties = useWatch({ name: "meta_properties" })
  // const action = useWatch({ name: "action" })

  // const [loadingDynamicProperties, setLoadingDynamicProperties] = useState(false)
  // const [dynamicProperties, setDynamicProperties] = useState<{ properties?: Property[]; optional_properties?: Property[] }>({
  //   properties: [],
  //   optional_properties: [],
  // })
  // const { selectedAction } = props

  // useEffect(() => {
  //   if (selectedAction?.dynamic_properties?.enabled) {
  //     setLoadingDynamicProperties(true)
  //     const values = props.form.getValues()
  //     store.scenario.actions
  //       .getNodeDynamicProperties({
  //         node_type: props.nodeType,
  //         action_id: selectedAction.id,
  //         properties: selectedAction.dynamic_properties.depends_on.reduce(
  //           (acc, x) => {
  //             acc[x] = values?.properties?.[x]
  //             return acc
  //           },
  //           {} as Record<string, any>,
  //         ),
  //         depends_on: selectedAction.dynamic_properties.depends_on,
  //       })
  //       .then((data) => {
  //         setDynamicProperties(data)
  //         setTimeout(() => {
  //           props.form.reset(undefined, {
  //             keepValues: true,
  //           })
  //         }, 100)
  //       })
  //       .finally(() => {
  //         setLoadingDynamicProperties(false)
  //       })
  //   }
  // }, [props.form, props.nodeType, selectedAction])

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-4 px-5">
        <div className="min-h-[60px]">
          <FormField name="action" label="Action">
            <Combobox
              fluid
              // options={props.actionOrGroups?.map((actionOrGroup) => ({ label: actionOrGroup.label || "", value: actionOrGroup.id })) || []}
              optionsGroups={props.nodeDef.actions?.map((act) => ({
                label: act.label || "",
                options: act.operations?.map((operation) => ({ label: operation.label, value: `${act.id}::${operation.id}` })),
              }))}
              onValueChange={(value) => {
                // props.form.setValue("action", value)

                props.form.resetField("properties", {
                  defaultValue: {
                    ...props.nodeDef.default_properties_values,
                    // ...props.allActions?.find((action) => action.id === value)?.default_properties_values,
                    ...props.actionOperationsRecord[value]?.default_properties_values,
                  },
                })
                props.form.resetField("meta_properties", { defaultValue: {} })
              }}
              placeholder="Select an action"
              className="w-full"
            />
            {/* <Select>
            <SelectTrigger>
              <SelectValue placeholder={"Select an action"} />
            </SelectTrigger>
            <SelectContent>
              {props.actionOrGroups?.map((actionOrGroup) => {
                if (actionOrGroup.type === "action_group") {
                  return (
                    <SelectGroup key={actionOrGroup.label}>
                      <SelectLabel>{actionOrGroup.label}</SelectLabel>
                      {actionOrGroup.actions?.map((action) => {
                        return (
                          <SelectItem key={action.id} value={action.id}>
                            {action.label}
                          </SelectItem>
                        )
                      })}
                    </SelectGroup>
                  )
                }
                return (
                  <SelectItem key={actionOrGroup.id} value={actionOrGroup.id}>
                    {actionOrGroup.label}
                  </SelectItem>
                )
              })}
            </SelectContent>
          </Select> */}
          </FormField>
        </div>
        {props.selectedOperation && (
          <FormBuilder
            properties={props.actionOperationProperties}
            form={props.form}
            node_type={props.nodeType}
            action_id={props.actionId}
            operation_id={props.operationId}
          />
        )}
        {/* {loadingDynamicProperties && <Spin className="w-full h-10" />} */}
      </div>
      {props.selectedOperation?.optional_properties?.properties?.length && (
        <OptionalProperties
          meta_properties={props.meta_properties}
          optionalProperties={props.optionalActionOperationProperties}
          form={props.form}
          label={props.selectedOperation?.optional_properties?.label}
          tip={props.selectedOperation?.optional_properties?.tip}
          node_type={props.nodeType}
          action_id={props.actionId}
          operation_id={props.operationId}
        />
      )}
    </div>
  )
}

export default ActionFormBuilder
